import { defineMessages } from 'react-intl-next';

export const messages: {
    resultLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	resultLabel: {
		id: 'dynamic-cards-search-page.github-commit-result.label',
		defaultMessage: 'Commit',
		description: 'GitHub commit label that is shown as part of the metadata below the commit title in the search results, for example "Commit • frontend-repository • Updated 2 hours ago"',
	},
});
